module.exports = __webpack_public_path__ + "img/LoginImg.196fe532.svg";